// extracted by mini-css-extract-plugin
export var active = "SLndZyXYTnMdUMYFJGue";
export var body = "CU2cKQ7q10kohKvAzudz ir6fasvX8UNxTj_lW0eJ";
export var destructive = "xyG9ighZS0IF2rj0dzVC";
export var focusVisible = "jJJfwyUYn0Pddgg7oj4R";
export var fontWeightNormal = "a8ex5OLKN7iREqgXKb7W";
export var fullWidth = "lAPDy0MRUaa8uLgAcM4L";
export var ghost = "mwIY8SghdT5foi6Xe_Gp";
export var icon = "lFWb9Zq74jPjZVBq2GmH";
export var iconWrapper = "RK7iUDvClA2gzfIEtCiQ";
export var large = "xT20wHfzqn3evC7ulaVo Sv6zdKPLSKHIln4NRc90";
export var link = "MDx3rt7u3B0Napj_c99m";
export var micro = "hpuX7thGGsp50dBxkvrA HIaKJ8sx0EqTbUlzrhdy";
export var mini = "hs8OPMGIelGl3UXyVAG0 K3hr9VVB7J4GT566KsG6";
export var primary = "ldnP5dU4ABz1HVwgIAmj";
export var root = "qNqJit5H7WvTpUnmd4b6";
export var secondary1 = "rUOeutnaQJ7zX952Rt2l";
export var secondary2 = "MZXve3nf2utLYXlSaEaK";
export var secondary3 = "wC_WY72LYDD4FJMTAGM8";
export var small = "n_rZ4gW61y_YSOiWm7wf clQKYKBOEaJX4Qe2c8A1";
export var spinner = "WRiJc2E59boG5Bd4Nf9F";
export var tertiary = "gaPAvaootYWqRqytA14S";
export var title2 = "Fdwowh1FKzORmla6u4gY zDwbdz5YK_9LB5kNdsK6";
export var title3 = "_LbryKookqs7ZSe_0R4g WsLQHYS83Z65gchJmUTw";
export var title4 = "rzuXkckHGEAXSSaiDduj yzzRytKS_YOKtkJLEmLw";